{
  "sidenavMenuCloseTooltip": "メニューを閉じる",
  "sidenavMenuLockTooltip": "クリックしてメニューをロック",
  "toggleSideNav": "サイドナビゲーションメニューを切り替え"
}
